export default angular
  .module('verifyApp.compile', ['ngSanitize'])
  .directive('compile', ['$compile', ($compile) => {
    return (scope, element, attrs) => {
      scope.$watch(
        (scopeTmp) => scopeTmp.$eval(attrs.compile),
        (value) => {
          element.html(value);
          $compile(element.contents())(scope);
        }
      );
    };
  }])
  .name;



// WEBPACK FOOTER //
// ./client/components/compile/index.js